export default __webpack_public_path__ + "static/media/track.f3f8edda.mp4";